export const STREAM_STATUS = {
  INITIALIZED: 'INITIALIZED',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  FINISHED: 'FINISHED',
  INTERRUPTED: 'INTERRUPTED',
};
export const STREAM_DIRECTION = {
  IN: 'in',
  OUT: 'out',
};
